// extracted by mini-css-extract-plugin
export var flush = "V09I0OGTWVY2tZVD9Grn";
export var headerWithIcon = "qNA0QKmJkL5_UYnKrfX3";
export var leftBorder = "ltNvwInZ15QeeZXSSSOg";
export var leftBorderInfo = "umbDl60EDG7q8urCerEg";
export var leftBorderNegative = "b0i04Iad8YFvoDfQ4a1n";
export var leftBorderPositive = "Vri7jljGK3LDCEDiWIUw";
export var leftBorderWarning = "YaBSzI8XlgcZrrWWeuu3";
export var message = "BsNux7KG6q5xC3NmkbAx";
export var messageHeader = "yWf3LcZRRiGDFjEK16b6";
export var trailingItem = "eSjeXbF_sVRGclGNdnJa";
export var vertical = "YcOmgf48k7V9Ck5h5ULQ";